import { Form } from 'antd';
import {
  acceptedFileTypesValidator,
  fileSizeValidator,
  Icon,
  InlineFileUploaderInput,
  maxFileNumberValidator,
  OFFICE_STUFF_FILE_TYPES,
} from '@common/components';
import React from 'react';

export const DisputeFilesInput = ({
  maxFilesSlots,
}: {
  maxFilesSlots: number;
}) => (
  <div className="dispute-files-input">
    <Form.Item
      name="files"
      rules={[
        { validator: fileSizeValidator(25) },
        { validator: maxFileNumberValidator(maxFilesSlots, 3) },
        {
          validator: acceptedFileTypesValidator(OFFICE_STUFF_FILE_TYPES),
        },
      ]}
    >
      <InlineFileUploaderInput
        instruction={
          <Icon
            icon="circleInfo"
            kind="solid"
            size="sm"
            color="steelDarker"
            tooltipText="Max. file size: 25MB, Max. no. files: 3"
          />
        }
      />
    </Form.Item>
    <style jsx global>{`
      .dispute-files-input {
        max-width: 100%;
      }
      .dispute-files-input .ant-form-item-control-input {
        /* Fixes input being jumpy when empty vs with items */
        align-items: initial;
        min-height: initial;
      }
      .dispute-files-input .ant-form-item {
        margin-bottom: 0px;
      }
      .dispute-files-input .ant-form-item-explain {
        margin-top: 8px;
      }
    `}</style>
  </div>
);
